// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--2yetU","link":"footer-module--link--2TsFU"};